document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Gallery: thumb click swaps main slide ---------- */
  document.querySelectorAll('.cro-gallery').forEach(function (gallery) {
    var thumbs = gallery.querySelectorAll('.cro-gallery__thumb');
    var slides = gallery.querySelectorAll('.cro-gallery__slide');

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = thumb.getAttribute('data-index');

        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');

        slides.forEach(function (slide) {
          slide.classList.toggle('is-active', slide.getAttribute('data-index') === index);
        });
      });
    });
  });

  /* ---------- Option swatches: basic UI state (wire to variant logic as needed) ---------- */
  document.querySelectorAll('.cro-option-values').forEach(function (group) {
    group.querySelectorAll('.cro-option-swatch').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        group.querySelectorAll('.cro-option-swatch').forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');

        var label = group.closest('.cro-option-block').querySelector('.cro-option-selected');
        if (label) label.textContent = btn.getAttribute('data-value');
      });
    });
  });

  /* ---------- Buy Now: submit form then redirect to checkout ---------- */
  document.querySelectorAll('[data-buy-now]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var form = btn.closest('.cro-product-form');
      if (!form) return;
      var formData = new FormData(form);

      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function () { window.location.href = '/checkout'; })
        .catch(function (err) { console.error('Buy now failed:', err); });
    });
  });

  /* ---------- Video Carousel: force autoplay (mobile-safe) ---------- */
  document.querySelectorAll('.cro-video-carousel__media video').forEach(function (video) {
    video.muted = true;
    video.playsInline = true;
    var tryPlay = function () { video.play().catch(function () {}); };
    tryPlay();
    video.addEventListener('loadedmetadata', tryPlay);
  });
});